import {
  Flex,
  Loader,
  MultiSelect,
  Text,
  type MultiSelectProps,
  type FlexProps,
} from '@mantine/core';
import classes from './FormMultiselect.module.scss';

//
//

interface FormMultiselectProps extends MultiSelectProps {
  title: string;
  description: string;
  value?: string[];
  containerProps?: FlexProps;
  isLoading?: boolean;
}

export const FormMultiselect = ({
  title,
  description,
  value,
  placeholder,
  containerProps,
  isLoading = false,
  disabled,
  rightSection,
  ...props
}: FormMultiselectProps) => {
  const displayValue = isLoading && value !== undefined ? [] : value;
  const displayPlaceholder =
    isLoading || (value && value.length > 0) ? '' : placeholder;

  return (
    <Flex gap='24' className={classes.formRow} {...containerProps}>
      <Flex direction='column' gap={6} className={classes.leftColumn}>
        <Text className={classes.title}>{title}</Text>
        <Text className={classes.description}>{description}</Text>
      </Flex>

      <MultiSelect
        placeholder={displayPlaceholder}
        value={displayValue}
        className={classes.rightColumn}
        variant='filled'
        rightSection={
          isLoading ? (
            <Loader size='xs' aria-label='Загрузка вариантов' />
          ) : (
            rightSection
          )
        }
        disabled={isLoading || disabled}
        {...props}
      />
    </Flex>
  );
};
